<template>
    <div class="text-no-wrap">
        <v-btn icon
               small
               @click="goTo('game-preferences')">
            <v-icon>mdi-settings</v-icon>
        </v-btn>
        <v-btn icon
               small
               v-if="graveyardActive"
               @click="goTo('game-graveyard')">
            <v-icon>mdi-grave-stone</v-icon>
        </v-btn>
        <v-btn icon
               small
               v-if="discardedActive"
               @click="goTo('game-discarded')">
            <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-btn icon
               small
               @click="goToReserve">
            <v-icon>mdi-cart</v-icon>
        </v-btn>

        <v-menu offset-y v-if="investigatorSessionsActive">
            <template v-slot:activator=" { on }">
                <v-btn icon
                       small
                       v-on="on">
                    <v-icon>mdi-account-multiple</v-icon>
                </v-btn>
            </template>
            <v-list>
                <template v-for="(investigatorSession, investigatorSessionIndex) in game.activeInvestigatorSessions">
                    <v-list-item :key="'navItem' + investigatorSessionIndex"
                                 @click="goToInvestigator(investigatorSessionIndex)">
                        <v-list-item-title>{{ investigatorSession.investigator.initial_and_surname }}</v-list-item-title>
                    </v-list-item>
                </template>
            </v-list>
        </v-menu>
    </div>
</template>

<script>

  export default {
    props: ["game"],

    computed: {
      graveyardActive: function () {
        if (this.$store.getters.game.graveyardInvestigatorSessions) {
          if (this.$store.getters.game.graveyardInvestigatorSessions.length) return true;
        }

        if (this.$store.getters.game.devouredInvestigatorSessions) {
          if (this.$store.getters.game.devouredInvestigatorSessions.length) return true;
        }

        return false;
      },

      investigatorSessionsActive: function () {
        return this.$store.getters.game.activeInvestigatorSessions.length;
      },

      discardedActive: function () {
        return this.$store.getters.game.discarded_cards.length;
      }
    },

    methods: {
      goToInvestigator(investigatorSessionIndex) {
        if (this.$route.params.tab !== investigatorSessionIndex) {
          this.$router.push({name: 'game', params: {gameId: this.game.id, tab: investigatorSessionIndex}});
        }
      },

      goToReserve() {
        if (this.$route.name !== 'game' || this.$route.name === 'game' && this.$route.params.tab !== -1) {
          this.$router.push({name: 'game', params: {gameId: this.game.id, tab: -1}});
        }
      },

      goTo(name) {
        if (this.$route.name !== name) {
          this.$router.push({name: name, params: {gameId: this.game.id}});
        }
      }
    }
  };
</script>
